/**
 * @typedef {Object} Message
 * @property {string|number} id
 * @property {any} [ticket]
 * @property {any} [contact]
 * @property {any} [user]
 */

/**
 * @typedef {Object} LoadMessagesAction
 * @property {"LOAD_MESSAGES"} type
 * @property {Message[]} payload
 */

/**
 * @typedef {Object} AddMessageAction
 * @property {"ADD_MESSAGE"} type
 * @property {Message} payload
 */

/**
 * @typedef {Object} UpdateMessageAction
 * @property {"UPDATE_MESSAGE"} type
 * @property {Partial<Message>} payload
 */

/**
 * @typedef {Object} ResetAction
 * @property {"RESET"} type
 */

/**
 * @typedef {LoadMessagesAction|AddMessageAction|UpdateMessageAction|ResetAction} MessageAction
 */

/**
 * Reducer para gerenciar estado de mensagens
 * @param {Message[]} state - Estado atual das mensagens
 * @param {MessageAction} action - Ação a ser executada
 * @returns {Message[]} Novo estado
 */
export const reducer = (state, action) => {
  if (action.type === "LOAD_MESSAGES") {
    const messages = action.payload
    const newMessages = []

    messages.forEach((message) => {
      const messageIndex = state.findIndex((m) => m.id === message.id)
      if (messageIndex !== -1) {
        state[messageIndex] = message
      } else {
        newMessages.push(message)
      }
    })

    return [...newMessages, ...state]
  }

  if (action.type === "ADD_MESSAGE") {
    const newMessage = action.payload
    const messageIndex = state.findIndex((m) => m.id === newMessage.id)

    if (messageIndex !== -1) {
      state[messageIndex] = newMessage
    } else {
      state.push(newMessage)
    }

    return [...state]
  }

  if (action.type === "UPDATE_MESSAGE") {
    const messageToUpdate = action.payload
    const messageIndex = state.findIndex((m) => m.id === messageToUpdate.id)

    if (messageIndex !== -1) {
      const oMensagemAnterior = state[messageIndex]
      // Edição não pode inverter o lado da mensagem (enviada → recebida).
      // O payload de edição às vezes chega com fromMe=false em mensagem própria de grupo.
      const lPreservarFromMe =
        oMensagemAnterior.fromMe === true &&
        messageToUpdate.isEdited === true &&
        messageToUpdate.fromMe === false

      const newState = [...state]
      newState[messageIndex] = {
        ...oMensagemAnterior,
        ...messageToUpdate,
        fromMe: lPreservarFromMe ? true : messageToUpdate.fromMe ?? oMensagemAnterior.fromMe,
        // Garantir que os campos essenciais não sejam perdidos
        ticket: messageToUpdate.ticket || oMensagemAnterior.ticket,
        contact: lPreservarFromMe
          ? oMensagemAnterior.contact
          : messageToUpdate.contact || oMensagemAnterior.contact,
        user: messageToUpdate.user || oMensagemAnterior.user,
      }
      return newState
    }

    return state
  }

  if (action.type === "RESET") {
    return []
  }
}
